import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { SegmentBoardEvent, segmentTrackAction } from '../../../../../../../../../middlewares/segment';
import {
    SegmentBoardOption,
    SegmentBoardOptionStatusValue
} from '../../../../../../../../../middlewares/segment/trackEntities/boardEvents';
import { ISegmentEventOption } from '../../../../../../../../../middlewares/segment/trackEntities/types';
import { EChatDashboardSettingsScope } from '../../../../../../../../../types/rest/IRestChatDashboardSettings';

export const onScopeClick = (
    scope: EChatDashboardSettingsScope,
    checked: boolean
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
    ) => {
        const option: ISegmentEventOption = {
            name: SegmentBoardOption.STATUS,
            value: checked ? SegmentBoardOptionStatusValue.ON: SegmentBoardOptionStatusValue.OFF
        }
        if (EChatDashboardSettingsScope.SETTING_ALL === scope) {
            dispatch(segmentTrackAction(SegmentBoardEvent.CHATS_SETTING_ALL_CLICKED, option,
                [{name: SegmentBoardOption.TYPE, value: EChatDashboardSettingsScope.SETTING_ALL}]));
        }
        if (EChatDashboardSettingsScope.SETTING_WHEN === scope) {
            dispatch(segmentTrackAction(SegmentBoardEvent.CHATS_SETTING_WHEN_CLICKED, option,
                [{name: SegmentBoardOption.TYPE, value: EChatDashboardSettingsScope.SETTING_WHEN}]));
        }
        if (EChatDashboardSettingsScope.SETTING_EVENT_I_CREATE_CARD === scope) {
            dispatch(segmentTrackAction(SegmentBoardEvent.CHATS_SETTING_EVENT_I_CREATE_CARD_CLICKED, option,
                [{name: SegmentBoardOption.TYPE, value: EChatDashboardSettingsScope.SETTING_EVENT_I_CREATE_CARD}]));
        }
        if (EChatDashboardSettingsScope.SETTING_I_AM_MENTIONED_IN_COMMENT === scope) {
            dispatch(segmentTrackAction(SegmentBoardEvent.CHATS_SETTING_I_AM_MENTIONED_IN_COMMENT_CLICKED, option,
                [{name: SegmentBoardOption.TYPE, value: EChatDashboardSettingsScope.SETTING_I_AM_MENTIONED_IN_COMMENT}]));
        }
        if (EChatDashboardSettingsScope.SETTING_CARD_ASSIGNED_TO_ME === scope) {
            dispatch(segmentTrackAction(SegmentBoardEvent.CHATS_SETTING_CARD_ASSIGNED_TO_ME_CLICKED, option,
                [{name: SegmentBoardOption.TYPE, value: EChatDashboardSettingsScope.SETTING_CARD_ASSIGNED_TO_ME}]));
        }
        if (EChatDashboardSettingsScope.SETTING_I_ADD_COMMENT === scope) {
            dispatch(segmentTrackAction(SegmentBoardEvent.CHATS_SETTING_I_ADD_COMMENT_CLICKED, option,
                [{name: SegmentBoardOption.TYPE, value: EChatDashboardSettingsScope.SETTING_I_ADD_COMMENT}]));
        }
    };
    return action;
};
